export default "__VITE_ASSET__DwUnnz1c__"